import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { tokenInterceptor } from './interceptors/token.interceptor';
import { ThemeService } from './services/theme.service';
import { StationStoreService } from './services/station-store.service';

function themeAppInitializer(theme: ThemeService): () => void {
  return () => theme.initFromStorage();
}

function stationStoreInitializer(store: StationStoreService): () => void {
  return () => store.initialize();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: themeAppInitializer,
      deps: [ThemeService],
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: stationStoreInitializer,
      deps: [StationStoreService],
    },

    // Functional interceptor avoids class-based DI ordering issues with AuthService/HttpClient
    // and reliably applies global 401 → session expiry handling to all HttpClient calls.
    provideHttpClient(withInterceptors([tokenInterceptor])),
  ]
};
